var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaletThecampWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "329px",
    height: "290px",
    viewBox: "0 0 329 290",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "galet-thecamp-white",
    transform: "translate(0.846202, 0.160190)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.053798,91.6398102 C279.253798,72.9398102 254.653798,43.1398102 226.853798,20.1398102 C197.053798,-4.46018978 165.853798,-6.36018978 131.753798,13.5398102 C95.0537977,35.1398102 57.6537977,94.8398102 45.2537977,114.13981 C16.7537977,159.33981 -30.4462023,234.73981 27.5537977,275.03981 C41.9537977,284.83981 59.6537977,289.73981 83.2537977,289.73981 C107.553798,289.73981 137.953798,285.13981 182.553798,276.93981 C262.853798,262.23981 299.553798,246.13981 318.253798,217.63981 C331.053798,196.83981 337.553798,158.13981 292.053798,91.6398102 Z M50.7537977,241.13981 C29.4537977,226.43981 47.1537977,188.73981 79.9537977,136.53981 C109.453798,89.6398102 133.753798,60.5398102 152.353798,49.3398102 C161.153798,44.1398102 169.053798,41.4398102 175.953798,41.4398102 C183.853798,41.4398102 191.353798,44.7398102 200.253798,51.9398102 C223.153798,70.9398102 245.853798,97.1398102 257.953798,114.83981 C282.853798,151.23981 292.053798,181.03981 283.153798,194.83981 C272.053798,211.83981 240.553798,224.03981 174.953798,236.13981 C101.953798,249.63981 68.4537977,253.23981 50.7537977,241.13981 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaletThecampWhite);
export default __webpack_public_path__ + "static/media/galet-thecamp-white.85f2f480b2f6a7a220fc618e81093a7c.svg";
export { ForwardRef as ReactComponent };